export default "__VITE_ASSET__bcf20d19__"